import loadable from '@loadable/component'
const Home = loadable(() => import(/* webpackChunkName: "Home" */ 'pages/Home'));
const HomeQA = loadable(() => import(/* webpackChunkName: "Home" */ 'pages/HomeQA'));
const Catalog = loadable(() => import(/* webpackChunkName: "Catalog", webpackPrefetch: true */ 'pages/Catalog'));
const Search = loadable(() => import(/* webpackChunkName: "Search", webpackPrefetch: true */ 'pages/Search'));
const Product = loadable(() => import(/* webpackChunkName: "Product", webpackPrefetch: true */ 'pages/Product'));
const Localities = loadable(() => import(/* webpackChunkName: "Localities" */ 'pages/Localities'));
const Benefits = loadable(() => import(/* webpackChunkName: "Benefits" */ 'pages/Benefits'));
const Tyc = loadable(() => import(/* webpackChunkName: "Tyc" */ 'pages/Tyc'));
const Information = loadable(() => import(/* webpackChunkName: "Tyc" */ 'pages/Information'));
const Services = loadable(() => import(/* webpackChunkName: "Services" */ 'pages/Services'));
const FrequentQuestions = loadable(() => import(/* webpackChunkName: "FrequentQuestions" */ 'pages/FrequentQuestions'));
const SecurityAndPrivacy = loadable(() => import(/* webpackChunkName: "SecurityAndPrivacy" */ 'pages/SecurityAndPrivacy'));
const CatalogInstitutional = loadable(() => import(/* webpackChunkName: "CatalogInstitutional" */ 'pages/CatalogInstitutional'));
const Providers = loadable(() => import(/* webpackChunkName: "Providers" */ 'pages/Providers'));
const Contest = loadable(() => import(/* webpackChunkName: "Contest" */ 'pages/Contest'));
const Contact = loadable(() => import(/* webpackChunkName: "Contact" */ 'pages/Contact'));
const UserAccountList = loadable(() => import(/* webpackChunkName: "UserAccountList" */ 'pages/UserAccountList'));
const UserBankAccount = loadable(() => import(/* webpackChunkName: "UserBankAccount" */ 'pages/UserBankAccount'));
const Cart = loadable(() => import(/* webpackChunkName: "Cart" */ 'pages/Cart'));
const Checkout = loadable(() => import(/* webpackChunkName: "Checkout" */ 'pages/Checkout'));
const CheckoutDelivery = loadable(() => import(/* webpackChunkName: "Checkout" */ 'pages/CheckoutDelivery'));
const Success = loadable(() => import(/* webpackChunkName: "Success" */ 'pages/Success'));
const OrderStatus = loadable(() => import(/* webpackChunkName: "OrderStatus" */ 'pages/OrderStatus'));
const School = loadable(() => import(/* webpackChunkName: "School" */ 'pages/School'));
const NewOffer = loadable(() => import(/* webpackChunkName: "NewOffer" */ 'pages/NewOffer'));
const AccountUser = loadable(() => import(/* webpackChunkName: "AccountUser" */ 'pages/AccountUser'));
const AccountOrders = loadable(() => import(/* webpackChunkName: "AccountOrders" */ 'pages/AccountOrders'));
const AccountList = loadable(() => import(/* webpackChunkName: "AccountList" */ 'pages/AccountList'));
const OrderDetail = loadable(() => import(/* webpackChunkName: "OrderDetail" */ 'pages/OrderDetail'));
const AccountCards = loadable(() => import(/* webpackChunkName: "AccountCards" */ 'pages/AccountCards'));
const Login = loadable(() => import(/* webpackChunkName: "AccountCards" */ 'pages/Login'));
const HelpCenter = loadable(() => import(/* webpackChunkName: "AccountCards" */ 'pages/HelpCenter'));
const HelpCenterQuestions = loadable(() => import(/* webpackChunkName: "HelpCenterQuestions" */ 'pages/HelpCenterQuestions'));
const HelpCenterPost = loadable(() => import(/* webpackChunkName: "HelpCenterPost" */ 'pages/HelpCenterPost'));
const AccountFrequentProducts = loadable(() => import(/* webpackChunkName: "frequentProducts" */ 'pages/AccountFrequentProducts'));
const AccountFavoriteProducts = loadable(() => import(/* webpackChunkName: "favoriteProducts" */ 'pages/AccountProductsFavorite'));
const NewCheckout = loadable(() => import(/* webpackChunkName: "favoriteProducts" */ 'pages/NewCheckout'));
const NewCart = loadable(() => import(/* webpackChunkName: "favoriteProducts" */ 'pages/NewCart'));
//const CommitmentsJumbo = loadable(() => import(/* webpackChunkName: "Commitments" */ 'pages/CommitmentsJumbo'));
const NewCommitmentsJumbo = loadable(() => import(/* webpackChunkName: "Commitments" */ 'pages/NewCommitmentsJumbo'));
const PrimePage = loadable(() => import(/* webpackChunkName: "PrimePage" */ 'pages/Prime'));
const LiveSale = loadable(() => import(/* webpackChunkName: "Commitments" */ 'pages/LiveSale'));
const LiveSaleDEV = loadable(() => import(/* webpackChunkName: "Commitments" */ 'pages/LiveSaleDEV'));



import Error404 from 'pages/Error404';
import Error404Help from 'pages/HelpCenter/Error404';

const routes = [
    {
        path: "/",
        component: Home
    },
    {
        path: "/home-qa",
        component: HomeQA
    },
    {
        path: "/index.html",
        component: Home
    },
    {
        path: "/login",
        component: Home
    },
    {
        path: "/registrate-prime",
        component: Home
    },
    {
        path: "/live-sale",
        component: LiveSale
    },
    {
        path: "/live-sale-dev",
        component: LiveSaleDEV
    },
    {
        path: "/register",
        component: Home
    },
    {
        path: "/_secure/cart",
        component: Cart
    },
    {
        path: "/_secure/cart/upselling",
        component: Cart
    },    
    {
        path: "/compromisos-jumbo",
        component: NewCommitmentsJumbo
    },
    {
        path: "/prime",
        component: PrimePage
    },
    {
        path: "/_secure/order/status/:orderId",
        component: OrderStatus
    },
    {
        path: "/_secure/orderDetail/:orderId",
        component: OrderDetail
    },
    {
        path: "/mis-compras/:orderId",
        component: OrderDetail
    },
    {
        path: "/mis-datos",
        component: AccountUser
    },
    {
        path: "/checkout",
        component: Checkout
    },
    {
        path: "/checkout/orderPlaced",
        component: Success
    },
    {
        path: "/checkout/split-delivery",
        component: CheckoutDelivery
    },
    {
        path: "/checkout/split-delivery/:index",
        component: CheckoutDelivery
    },
    {
        path: "/checkout/:slug",
        component: Checkout
    },
    {
        path: "/checkout/:slug/resume",
        component: Checkout
    },
    {
        path: "/:slug/p",
        component: Product
    },
    {
        path: "/Sistema/busquedavacia",
        component: Error404
    },
    {
        path: "/Sistema/404",
        component: Error404
    },
    {
        path: "/locales",
        component: Localities
    },
    {
        path: "/institucional/locales-jumbo",
        component: Localities
    },
    {
        path: "/institucional/beneficios",
        component: Benefits
    },
    {
        path: "/institucional/servicios",
        component: Services
    },
    {
        path: "/institucional/terminos-condiciones",
        component: Tyc
    },
    {
        path: "/institucional/seguridad-privacidad",
        component: SecurityAndPrivacy
    },
    {
        path: "/institucional/preguntas-frecuentes/:slug",
        component: FrequentQuestions
    },
    {
        path: "/institucional/preguntas-frecuentes",
        component: FrequentQuestions
    },
    {
        path: "/institucional/concursos",
        component: Contest
    },
    {
        path: "/institucional/catalogos",
        component: CatalogInstitutional
    },
    {
        path: "/institucional/contacto",
        component: Contact
    },
    {
        path: "/institucional/proveedores",
        component: Providers
    },
    {
        path: "/institucional/compromisos",
        component: NewCommitmentsJumbo
    },
    {
        path: "/informaciones/:slug",
        component: Information
    },
    {
        path: "/informaciones",
        component: Information
    },
    {
        path: "/lista-de-compra",
        component: UserAccountList
    },
    {
        path: "/mi-cuenta-bancaria",
        component: UserBankAccount
    },
    {
        path: "/_secure/account",
        component: AccountUser
    },
    {
        path: "/_secure/compras",
        component: AccountOrders
    },
    {
        path: "/mis-compras",
        component: AccountOrders
    },
    {
        path: "/_secure/listas-de-compras",
        component: AccountList
    },
    {
        path: "/mis-listas-de-compras",
        component: AccountList
    },
    {
        path: "/mis-tarjetas",
        component: AccountCards
    },
    {
        path: "/oferta/:slug",
        component: NewOffer
    },
    {
        path: "/busca",
        component: Catalog
    },
    {
        path: "/busqueda/:category1?/:category2?/:category3?",
        component: Search
    },
    {
        path: "/escolares",
        component: School
    },
    {
        path: "/escolares/:Id",
        component: School
    },
    {
        path: "/login-page",
        component: Login
    },
    {
        path: "/centro-ayuda",
        component: HelpCenter
    },
    {
        path: "/centro-ayuda/busqueda/:search",
        component: HelpCenterQuestions
    },
    {
        path: "/centro-ayuda/busquedavacia",
        component: Error404Help
    },
    {
        path: "/centro-ayuda/categoria/:slug",
        component: HelpCenterQuestions
    },
    {
        path: "/centro-ayuda/:slug",
        component: HelpCenterPost
    },
    {
        path: "/productos-frecuentes",
        component: AccountFrequentProducts
    },
    {
        path: "/productos-favoritos",
        component: AccountFavoriteProducts
    }, {
        path: "/new-checkout/:step",
        component: NewCheckout
    },
    {
        path: "/mi-carro",
        component: NewCart
    },
    {
        path: "/:category1/:category2?/:category3?",
        component: Catalog
    }

];

export {
    routes,
    Error404
};
